export { default as InputText } from './input-text'



// WEBPACK FOOTER //
// ./src/components/atoms/input-text/index.ts